import { ErrorsService } from "src/app/services/common/errors.service";
import { MajorDegreeService } from "src/app/services/http/business/majorDegree/major-degree.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatSelectChange,
  MatInput,
  MatSelect,
  MatDialogRef
} from "@angular/material";
import { FormGroup } from "@angular/forms";
import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import * as moment from "jalali-moment";

import { TranslateService } from "@ngstack/translate";
//import { IContractType } from "src/app/interfaces/contractType";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { RoleService } from "src/app/services/http/business/role/role.service";
import { IRole } from "src/app/interfaces/role";
import { IBranch } from "src/app/interfaces/branch";
import { IMajorDegree } from "src/app/interfaces/majorDegree";
import { IContract } from "src/app/interfaces/contract";
import { SoundEnum } from "src/app/enums/sound.enum";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
import { SettingService } from "src/app/services/http/business/setting/setting.service";
import { IContractInfo } from "src/app/interfaces/contractInfo";
import { HttpHeaders } from "@angular/common/http";
import { IError } from "src/app/interfaces/error.interface";
//import { CIDService } from "src/app/services/common/cid.service";

@Component({
  selector: 'app-contract-edit',
  templateUrl: './contract-edit.component.html',
  styleUrls: ['./contract-edit.component.css']
})
export class ContractEditComponent implements OnInit {
  roleList: IRole;
  form: FormGroup;
  branchList: IBranch;
  contractNumber: any;
  numbers: number[] = [];
  degreeList: IMajorDegree;
  btnDisable: boolean = false;
  //contractType: IContractType;
  majorList: IMajorDegree[];
  minDate: any;
  contractTypeList: IContractInfo
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = []
  branchSelection: any;
  selected = new FormControl();;

  @ViewChild("fromInput", { read: MatInput }) fromInput: MatInput;

  constructor(
    private fb: FormBuilder,
    private roleService: RoleService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private branchService: BranchService,
    //private cidService: CIDService,
    private settingService: SettingService,
    private staticValue: StaticValueService,
    private majorService: MajorDegreeService,
    private contractService: ContractService,
    @Inject(MAT_DIALOG_DATA) public data: IContract,
    private dialogRef: MatDialogRef<ContractEditComponent>
  ) {


  }

  ngOnInit() {
    this.getRoles();
    this.getMajor();
    this.createForm();
    this.fillNumber();
    //this.setMindate();
    this.getBranchList(this.data.CompanyEncryptId);
    this.getContractType();
    //this.setContractNumber();
    this.setDefaultInsurance();

    this.majorService.degreeList(this.data.DegreeId).subscribe(
      res => {
        this.majorList = res.EduMajors;
      },
      () => {
        this.errorService.transactionError();
      }
    );
    this.branchSelection = this.data.ContractBranch.join();

    this.form.controls['ContractTypeId'].patchValue(this.data.ContractTypeId);
  }

  createForm() {
    this.form = this.fb.group({
      Id: [this.data.Id],
      // FirstName: [""],
      // LastName: [""],
      NationalCode: [
        this.data.NationalCode.toString(),
        Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(12)])
      ],
      Gender: [this.data.Gender, Validators.compose([Validators.required])],
      PersonCode: [this.data.PersonCode, Validators.compose([Validators.maxLength(50)])],
      RoleId: [this.data.RoleId, Validators.compose([Validators.required])],
      ContractNumber: [this.data.ContractNumber],
      ContractTypeId: [this.data.ContractTypeId],
      HasTax: [this.data.HasTax],
      HasInsurance: [this.data.HasInsurance],
      InsuranceDayPerMonth: [this.data.InsuranceDayPerMonth, Validators.compose([Validators.required])],
      ContractStartDate: [this.data.ContractStartDate, Validators.compose([Validators.required])],
      ContractEndDate: [this.data.ContractEndDate, Validators.compose([Validators.required])],
      ContractBranch: [this.data.ContractBranch],
      DegreeId: [this.data.DegreeId ? this.data.DegreeId.toString() : null, Validators.compose([Validators.required])],
      MajorId: [this.data.MajorId ? this.data.MajorId.toString() : null, Validators.compose([Validators.required])],
      ActivateCode: [this.data.ActivateCode],
      BranchEncryptId: [null],
      Description: [this.data.Description],
      IsAsset: [this.data.IsAsset],
      IsSub: [this.data.IsSub],
      CanPlacement: [this.data.CanPlacement]
      //placementTeacher: [this.data., Validators.compose([Validators.required])]
    });
    //this.globalmarketCategory
    this.selected.setValue(Array.prototype.map.call(this.data.ContractBranch, s => s.BranchEncryptId));// = Array.prototype.map.call(this.data.ContractBranch, s => s.BranchEncryptId).toString();
    //this.selected = Array.prototype.map.call(this.data.ContractBranch, s => s.BranchEncryptId).toString();
    //this.form.controls['BranchEncryptId'].setValue(this.data.ContractBranch)
  }
  // getContractType() {
  //   this.staticValue.ContractType().subscribe(res => {
  //     this.contractType = res;
  //   });
  // }

  getContractType() {
    this.staticValue.ContractType().subscribe(res => {
      this.contractTypeList = res;
    });
  }
  comparer(o1: any, o2: any): boolean {
    // if possible compare by object's name property - and not by reference.
    return o1 === o2;
  }

  fillNumber() {
    for (let i = 31; i >= 1; i--) {
      this.numbers.push(i);
    }
  }

  onChange(event: MatSelectChange) {
    if (event.value === "true") {
      this.form.controls["InsuranceDayPerMonth"].patchValue(null);
      this.btnDisable = false;
    } else {
      this.form.controls["InsuranceDayPerMonth"].patchValue(0);
      this.btnDisable = true;
    }
  }

  getRoles() {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.data.CompanyEncryptId
      );
    this.roleService.listByHeader(0, 0, headers).subscribe(
      res => {
        this.roleList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setContractNumber() {
    this.settingService.getIndicator().subscribe(
      res => {
        this.contractNumber = res.IndicatoNumber;
        this.form.controls["ContractNumber"].patchValue(res.IndicatoNumber);
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  reset() {
    this.fromInput.value = null;
    this.form.controls["LeavingJobDate"].setValue(null);
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getMajor() {
    this.majorService.list().subscribe(
      res => {
        this.degreeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadMajor(element: MatSelect) {
    this.majorService.degreeList(element.value).subscribe(
      res => {
        this.majorList = res.EduMajors;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setMindate() {
    this.settingService.getContractDate().subscribe(
      res => {
        this.minDate = moment.from(res.Date.toString(), "en");
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setDefaultInsurance() {
    this.form.controls["HasInsurance"].setValue(false);
  }

  getRoleId(id: number) {
    this.form.controls["RoleId"].patchValue(id);
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit() {

    // if (data.BranchEncryptId) {
    //   var brGuidList = data.BranchEncryptId;
    //   var convertArrtoObject = new Array();
    //   brGuidList.forEach(x => {
    //     convertArrtoObject.push({ BranchEncryptId: x });
    //   });
    // }
    var ls = [];
    this.selected.value.forEach(element => {
      ls.push({
        BranchEncryptId: element
      })
    });
    this.form.controls["ContractBranch"].setValue(ls);

    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.data.CompanyEncryptId
      );

    this.contractService.editByHeader(this.form.value, headers).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.onNoClick();
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
}
